import { render, staticRenderFns } from "./SfPhotosField.vue?vue&type=template&id=54bc754b&scoped=true"
import script from "./SfPhotosField.vue?vue&type=script&lang=ts"
export * from "./SfPhotosField.vue?vue&type=script&lang=ts"
import style0 from "./SfPhotosField.vue?vue&type=style&index=0&id=54bc754b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bc754b",
  null
  
)

export default component.exports